export default class Dialog {
    constructor(dialogLinkClass) {
        this._dialog = null;

        const linkButtons = document.getElementsByClassName(dialogLinkClass);
        for (let i = 0; i < linkButtons.length; i++) {
            linkButtons[i].addEventListener('click', this.openDialog.bind(this), false);
        }
    }

    openDialog(event) {
        if (this._dialog === null || this._dialog.closed) {
            event.preventDefault();
            const target = event.currentTarget;
            if (target instanceof HTMLAnchorElement) {
                const url = target.href;
                const width = document.documentElement.clientWidth;
                const height = document.documentElement.clientHeight;
                const windowX = (window.screen.availWidth - width) / 2;
                const windowY = (window.screen.availHeight - height) / 2;
                const features = `menubar=no,toolbar=no,location=no,directories=yes,resizable=yes,scrollbars=yes,dependent=yes,dialog=yes,minimizable=yes,left=${windowX},top=${windowY},height=${height},width=${width}`;
                this._dialog = window.open(url, 'list', features);
            }
            this._dialog?.focus();
        }
    }
}